/**
 * @desc 根据userNo获取本部门名称及部门主管名称(包括所有父级部分),无返回=不是内部员工,deptList为空=员工未配置部门,supervisorUserCode为空=该部门无领导
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(userNo: string | number, options?: any) {
  return updateResponse(
    http(URL + `/organizationStaff/getAllDeptAndManager/${userNo}`, {
      method: "GET",

      ...options,
    }),
  );
}
